/**
 * @license The MIT License (MIT)
 * @copyright Stanislav Kalashnik <darkpark.main@gmail.com>
 */

'use strict';

var Emitter = require('cjs-emitter');


// /**
//  * Base component implementation.
//  *
//  * Visual element that can handle sub-components.
//  * Each component has a DOM element container $node with a set of classes:
//  * "component" and some specific component class names depending on the hierarchy, for example "page".
//  * Each component has a unique ID given either from $node.id or from data.id. If not given will generate automatically.
//  *
//  * @constructor
//  * @extends Emitter
//  *
//  * @param {Object} [config={}] init parameters
//  * @param {Element} [config.id] component unique identifier (generated if not set)
//  * @param {string} [config.className] space-separated list of classes for "className" property of this.$node
//  * @param {Element} [config.$node] DOM element/fragment to be a component outer container
//  * @param {Element} [config.$body] DOM element/fragment to be a component inner container (by default is the same as $node)
//  * @param {Component} [config.parent] link to the parent component which has this component as a child
//  * @param {Array.<Component>} [config.children=[]] list of components in this component
//  * @param {Object.<string, function>} [config.events={}] list of event callbacks
//  * @param {boolean} [config.visible=true] component initial visibility state flag
//  * @param {boolean} [config.focusable=true] component can accept focus or not
//  * @param {boolean} [config.propagate=false] allow to emit events to the parent component
//  *
//  * @fires module:stb/component~Component#click
//  *
//  * @example
//  * var component = new Component({
//  *     $node: document.getElementById(id),
//  *     className: 'bootstrap responsive',
//  *     events: {
//  *         click: function () { ... }
//  *     }
//  * });
//  * component.add( ... );
//  * component.focus();
//  */
function Component ( config ) {
    // current execution context
    var self      = this,
        //focusable = false,
        classList, modifiers,
        $node;


    // parent constructor call
    Emitter.call(this);

    /** @protected */
    this.private = {
        hidden: false,
        focusable: false,
        focused: false
    };

    // apply custom name
    config.name && (this.name = config.name);

    // component DOM container (empty div in case nothing is given)
    //this.$node = $node = config.id ? document.getElementById(config.id) : config.$node || document.createElement('div');
    this.$node = $node = config.$node || document.createElement('div');

    // to do: use/remove
    //this.$node.removeAttribute('id');

    // sanitize
    modifiers = config.modifiers || [];


    classList = [this.name];

    // there are some block modifiers
    if ( modifiers.length ) {
        // build class names
        modifiers.forEach(function ( modifier ) {
            classList.push(self.name + '--' + modifier);
        });
    }

    // append all new classes to the existing ones
    //$node.classList.add.apply($node.classList, classList);
    $node.className += classList.join(' ');

    config.focusable && (this.focusable = true);

    // set focus if can and necessary
    config.focusable && config.focused && (this.focused = true);

    config.hidden && (this.hidden = true);

    config.content && this.add.apply(this, config.content);

    // apply all given events
    config.events && this.addListeners(config.events);


    if ( DEVELOP ) {
        this.counters[this.constructor.name] = this.counters[this.constructor.name] || 0;
        this.counters[this.constructor.name]++;

        // expose inner ID to global scope
        this.$node.dataset.name = 'component' + this.constructor.name + this.counters[this.constructor.name];
        window[this.$node.dataset.name] = this;

        $node.addEventListener('click', function ( event ) {
            var time = Date.now();

            if ( event.ctrlKey ) {
                event.stopPropagation();
                window.link = self;
                window['c' + time] = self;

                console.group('component info');
                console.log(self);
                console.log($node.getBoundingClientRect());
                console.log('in DEVELOP mode this component is available in the global scope as "%s"', self.$node.dataset.name);
                console.groupEnd();
            }
        });

        // expose a link
        Object.defineProperty($node, 'component', {
            get: function () {
                console.warn('Accessing the associated component from a DOM node is a development-only feature!');

                return self;
            }
        });

        window['Component' + this.constructor.name] = this.constructor;

        //$node.component = this.$body.component = this;
        //$node.component = this;
        //$node.title = this.constructor.name + '#' + this.id + ' (outer)';
        //$node.title = this.name + ' instance of ' + this.constructor.name;
        //this.$body.title = this.name + '#' + this.id + ' (inner)';
    }

    //if ( this.focusable ) {}

    // debug.info('create component ' + this.name + '#' + this.id, null, {
    //     tags: ['create', 'component', this.name, this.id]
    // });
    //return this;
}


// inheritance
Component.prototype = Object.create(Emitter.prototype);
Component.prototype.constructor = Component;


Object.defineProperties(Component.prototype, {
    focusable: {
        get: function () {
            return this.private.focusable;
        },
        set: function ( value ) {
            var self      = this,
                $node     = this.$node,
                nodeClass = this.name + '--focused';

            // sanitize
            value = !!value;

            // nothing has changed
            if ( this.private.focusable === value ) {
                console.warn('focusable: current and new values are identical', value, this);
            } else {
                // save
                this.private.focusable = value;

                // apply
                if ( value ) {
                    // has focus
                    $node.setAttribute('tabIndex', '0');

                    // prepare focus handlers
                    this.private.onfocus = function onFocus ( event ) {
                        // apply
                        $node.classList.add(nodeClass);
                        DEVELOP && $node.classList.add('develop-focused');
                        // notify listeners
                        self.events.focus && self.emit('focus', event);
                    };
                    this.private.onblur = function onFocus ( event ) {
                        // apply
                        $node.classList.remove(nodeClass);
                        DEVELOP && $node.classList.remove('develop-focused');
                        // notify listeners
                        self.events.blur && self.emit('blur', event);
                    };

                    // add handlers
                    $node.addEventListener('focus', this.private.onfocus);
                    $node.addEventListener('blur', this.private.onblur);
                } else {
                    // does not have focus
                    $node.removeAttribute('tabIndex');

                    // remove handlers
                    $node.removeEventListener('focus', this.private.onfocus);
                    $node.removeEventListener('blur', this.private.onblur);

                    // clear
                    delete this.private.onfocus;
                    delete this.private.onblur;

                    // blur just in case
                    this.focused = false;
                }
            }
        }
    },

    focused: {
        get: function () {
            return this.private.focused;
        },
        set: function ( value ) {
            // apply
            if ( value ) {
                this.$node.focus();

                if ( document.activeElement !== this.$node ) {
                    console.warn('focused: fail to focus or not focusable', value, this);
                }
            } else {
                this.$node.blur();
            }
        }
    },

    hidden: {
        get: function () {
            return this.private.hidden;
        },
        set: function ( value ) {
            var $node     = this.$node,
                nodeClass = this.name + '--hidden';

            // sanitize
            value = !!value;

            // nothing has changed
            if ( this.private.hidden === value ) {
                console.warn('hidden: current and new values are identical', value, this);
            } else {
                // save
                this.private.hidden = value;

                // apply
                if ( value ) {
                    // hide
                    $node.classList.add(nodeClass);
                    // notify listeners
                    this.events.hide && this.emit('hide');
                } else {
                    // show
                    $node.classList.remove(nodeClass);
                    // notify listeners
                    this.events.show && this.emit('show');
                }
            }
        }
    }
});


if ( DEVELOP ) {
    // expose constructor to global scope
    window.Component = Component;

    Component.prototype.counters = {};
}


/**
 * List of all default event callbacks.
 *
 * @type {Object.<string, function>}
 */
//Component.prototype.defaultEvents = null;


/**
 * Add a new component as a child.
 *
 * //@param {...Component} [child] variable number of elements to append
 *
 * //@files Component#add
 *
 * @example
 * panel.add(
 *     new Button( ... ),
 *     new Button( ... )
 * );
 */
Component.prototype.add = function () {
    var index, child;

    // walk through all the given elements
    for ( index = 0; index < arguments.length; index++ ) {
        child = arguments[index];

        // if ( DEVELOP ) {
        //     if ( !(child instanceof Component) ) {
        //         throw new Error(__filename + ': wrong child type');
        //     }
        // }

        this.$node.appendChild(child.$node || child);

        // // apply
        // this.children.push(child);
        // child.parent = this;
        //
        // // correct DOM parent/child connection if necessary
        // if ( child.$node && child.$node.parentNode === null ) {
        //     this.$body.appendChild(child.$node);
        // }
        //
        // debug.info('add component ' + child.name + '#' + child.id + ' to ' + this.name + '#' + this.id, null, {
        //     tags: ['add', 'component', this.name, this.id, child.name, child.id]
        // });
        //
        // // there are some listeners
        // if ( this.events.add ) {
        //     /**
        //      * A child component is added.
        //      *
        //      * @event module:stb/component~Component#add
        //      *
        //      * @type {Object}
        //      * @property {Component} item new component added
        //      */
        //     this.emit('add', {item: child});
        // }
        //
        // //debug.log('component ' + this.name + '#' + this.id + ' new child: ' + child.name + '#' + child.id);
    }
};


/* @todo: consider activation in future */
///**
// * Insert component into the specific position.
// *
// * @param {Component} child component instance to insert
// * @param {number} index insertion position
// */
//Component.prototype.insert = function ( child, index ) {
//    var prevIndex = this.children.indexOf(child);
//
//    if ( DEVELOP ) {
//        if ( arguments.length !== 2 ) { throw new Error(__filename + ': wrong arguments number'); }
//        if ( !(child instanceof Component) ) { throw new Error(__filename + ': wrong child type'); }
//    }
//
//    if ( prevIndex !== -1 ) {
//        this.children.splice(prevIndex, 1);
//        this.$body.removeChild(child.$node);
//    }
//
//    if ( index === this.children.length ) {
//        this.$body.appendChild(child.$node);
//    } else {
//        this.$body.insertBefore(child.$node, this.$body.children[index]);
//    }
//    this.children.splice(index, 0, child);
//
//    if ( !child.parent ) {
//        child.parent = this;
//    }
//};


/**
 * Delete this component and clear all associated events.
 *
 * //@fires module:stb/component~Component#remove
 */
Component.prototype.remove = function () {
    var $parent = this.$node.parentNode;

    // really inserted somewhere
    // if ( this.parent ) {
    //     if ( DEVELOP ) {
    //         if ( !(this.parent instanceof Component) ) {
    //             throw new Error(__filename + ': wrong this.parent type');
    //         }
    //     }
    //
    //     // active at the moment
    //     if ( app.activePage.activeComponent === this ) {
    //         this.blur();
    //         this.parent.focus();
    //     }
    //     this.parent.children.splice(this.parent.children.indexOf(this), 1);
    // }

    // remove all children
    // this.children.forEach(function ( child ) {
    //     if ( DEVELOP ) {
    //         if ( !(child instanceof Component) ) {
    //             throw new Error(__filename + ': wrong child type');
    //         }
    //     }
    //
    //     child.remove();
    // });

    //console.assert(this.$node.parentNode instanceof Element, 'wrong config type');

    // clear DOM
    $parent && $parent.removeChild(this.$node);

    // notify listeners
    this.events.remove && this.emit('remove');

    // remove all listeners
    this.events = {};

    //debug.log('component ' + this.name + '#' + this.id + ' remove', 'red');
    // debug.info('remove component ' + this.name + '#' + this.id, null, {
    //     tags: ['remove', 'component', this.name, this.id]
    // });
};


/**
 * Activate the component.
 * Notify the owner-page and apply CSS class.
 *
 * @return {boolean} operation status
 *
 * //@fires module:stb/component~Component#focus
 */
/*Component.prototype.focus = function () {
    this.$node.focus();

    // not already focused
    //if ( this.focusable && this !== focusComponent ) {
    // if ( this !== focusComponent ) {
    //     // notify the current focused component
    //     focusComponent && focusComponent.blur();
    //
    //     // apply
    //     this.$node.classList.add(this.name + '--focused');
    //     focusComponent = this;
    //
    //     if ( DEVELOP ) {
    //         this.$node.classList.add('develop-focused');
    //     }
    //
    //     // notify listeners
    //     this.events.focus && this.emit('focus', data);
    //
    //     // ok
    //     return true;
    // }

    // status
    return document.activeElement === this.$node;
};*/


/**
 * Remove focus.
 * Change page.activeComponent and notify subscribers.
 *
 * @return {boolean} operation status
 *
 * //@fires module:stb/component~Component#blur
 */
/*Component.prototype.blur = function () {
    this.$node.blur();

    // is it focused
    // if ( this === focusComponent ) {
    //     // apply
    //     this.$node.classList.remove(this.name + '--focused');
    //     focusComponent = null;
    //
    //     if ( DEVELOP ) {
    //         this.$node.classList.remove('develop-focused');
    //     }
    //
    //     // notify listeners
    //     this.events.blur && this.emit('blur');
    //
    //     // ok
    //     return true;
    // }

    // status
    return document.activeElement !== this.$node;
};*/


/**
 * Make the component visible and notify subscribers.
 *
 * //@param {Object} [data] - custom data which passed into handlers
 *
 * @return {boolean} operation status
 *
 * //@fires module:stb/component~Component#show
 */
/*Component.prototype.show = function () {
    if ( this.private.hidden ) {
        // correct style
        this.$node.classList.remove(this.name + '--hidden');
        // flag
        this.private.hidden = false;
        // notify listeners
        this.events.show && this.emit('show');

        // ok
        return true;
    }

    console.warn('component is already visible!', this);

    // status
    return false;
};*/


/**
 * Make the component hidden and notify subscribers.
 *
 * //@param {Object} [data] - custom data which passed into handlers
 *
 * @return {boolean} operation status
 *
 * //@fires module:stb/component~Component#hide
 */
/*Component.prototype.hide = function () {
    if ( !this.private.hidden ) {
        // correct style
        this.$node.classList.add(this.name + '--hidden');
        // flag
        this.private.hidden = true;
        // notify listeners
        this.events.hide && this.emit('hide');

        // ok
        return true;
    }

    console.warn('component is already hidden!', this);

    // status
    return false;
};*/


/*Component.prototype.enable = function ( data ) {
    if ( this.disabled ) {
        // correct style
        this.$node.classList.remove(this.name + '--disabled');
        // flag
        this.disabled = false;
        // notify listeners
        this.events.enable && this.emit('enable', data);

        // ok
        return true;
    }

    // status
    return false;
};


Component.prototype.disable = function ( data ) {
    if ( !this.disabled ) {
        // remove focus
        this.blur();

        // correct style
        this.$node.classList.add(this.name + '--disabled');
        // flag
        this.disabled = true;
        // notify listeners
        this.events.disable && this.emit('disable', data);

        // ok
        return true;
    }

    // status
    return false;
};*/


// public
module.exports = Component;
